import { render, staticRenderFns } from "./EncerrarAtendimento.vue?vue&type=template&id=0f13f02a&"
import script from "./EncerrarAtendimento.vue?vue&type=script&lang=js&"
export * from "./EncerrarAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports